import React from "react";
import { useAzureSubscriptions } from "../hooks/useAzureSubscriptions";
import { useAzureProviders } from "../hooks/useAzureProviders";
import { useAzureResources } from "../hooks/useAzureResources";

export default function AzureOverview() {
  const subs = useAzureSubscriptions();
  const prov = useAzureProviders();
  const res  = useAzureResources();

  return (
    <div style={{padding:16}}>
      <h2>Azure – données réelles</h2>

      <h3>Subscriptions</h3>
      {subs.loading ? "Chargement…" :
       subs.error ? <span style={{color:"red"}}>{subs.error}</span> :
       subs.data.length === 0 ? <em>Aucune</em> :
       <ul>{subs.data.map(s => (
         <li key={s.subscriptionId}>
           <b>{s.displayName}</b> ({s.subscriptionId}) – {s.state}
         </li>
       ))}</ul>}

      <h3>Providers</h3>
      {prov.loading ? "Chargement…" :
       prov.error ? <span style={{color:"red"}}>{prov.error}</span> :
       prov.data.length === 0 ? <em>Aucun</em> :
       <ul>{prov.data.slice(0,30).map(p => (
         <li key={p.namespace}>{p.namespace} – {p.registrationState}</li>
       ))}</ul>}

      <h3>Ressources Terraform (AzureRM)</h3>
      {res.loading ? "Chargement…" :
       res.error ? <span style={{color:"red"}}>{res.error}</span> :
       res.resources.length === 0 ? <em>Aucune</em> :
       <ul>{res.resources.slice(0,50).map(r => <li key={r}>{r}</li>)}</ul>}
      <small>Affichage limité pour la page – la sidebar utilisera la liste complète.</small>
    </div>
  );
}
